import React from 'react'

export const GoogleIcon = ({ className, ...props }) => {
  return (
    <svg
      width='25'
      height='26'
      viewBox='0 0 25 26'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      {...props}
    >
      <path
        d='M24.9868 13.2434C24.9868 12.1781 24.9018 11.4008 24.7177 10.5947H12.749V15.4025H19.7744C19.6328 16.5973 18.8679 18.3967 17.1682 19.6058L17.1444 19.7668L20.9286 22.7461L21.1908 22.7727C23.5987 20.5127 24.9868 17.1875 24.9868 13.2434Z'
        fill='#4285F4'
      />
      <path
        d='M12.7491 25.9109C16.1909 25.9109 19.0804 24.7593 21.1909 22.7728L17.1683 19.6059C16.0918 20.3688 14.647 20.9014 12.7491 20.9014C9.37804 20.9014 6.51691 18.6415 5.49699 15.5178L5.3475 15.5307L1.41254 18.6256L1.36108 18.771C3.45736 23.0031 7.76327 25.9109 12.7491 25.9109Z'
        fill='#34A853'
      />
      <path
        d='M5.49685 15.5178C5.22773 14.7117 5.07199 13.8479 5.07199 12.9555C5.07199 12.063 5.22773 11.1993 5.48269 10.3932L5.47556 10.2215L1.4913 7.0769L1.36094 7.13992C0.49697 8.89611 0.0012207 10.8682 0.0012207 12.9555C0.0012207 15.0427 0.49697 17.0148 1.36094 18.7709L5.49685 15.5178Z'
        fill='#FBBC05'
      />
      <path
        d='M12.7491 5.00937C15.1428 5.00937 16.7574 6.06018 17.6781 6.93833L21.2758 3.36839C19.0663 1.28114 16.1909 0 12.7491 0C7.76325 0 3.45735 2.90773 1.36108 7.13978L5.48283 10.3931C6.5169 7.26938 9.37803 5.00937 12.7491 5.00937Z'
        fill='#EB4335'
      />
    </svg>
  )
}
